import React from "react";
import {useNavigate} from "react-router-dom";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";

import Icon from "layout/atoms/Icon";

import {Wrapper} from "./styles";
import { ReactComponent as ArrowSvg } from "assets/icons/arrow2/right.svg";
import Label from "layout/atoms/Label";
import { ReactComponent as PublicSvg } from "../../../assets/icons/globe2.svg";
import { ReactComponent as PrivateSvg } from "../../../assets/icons/lock.svg";

const BoardCard = ({ boardData }) => {
  const { t } = useTranslation();
  let navigate = useNavigate();

  return (
    <Wrapper
      key={boardData.id}
      active={boardData.active}
      header={
        <div>
          <h3><Icon src={boardData.isPublic ? PublicSvg : PrivateSvg} size={"16px"}/> {boardData.name}</h3>
          {boardData.shortDescription && (
            <p style={{ fontSize: '13px', color: '#6e7681', marginTop: '6px', lineHeight: '1.5' }}>
              {boardData.shortDescription}
            </p>
          )}
          {!boardData.active && (
            <Label size="s" status="REVIEW">
              {t("statuses.INACTIVE_BOARD")}
            </Label>
          )}
        </div>
      }
      footer={
        <div>
          <Icon src={ArrowSvg} />
        </div>
      }
      onClick={() => navigate(`/admin/boards/${boardData.id}/list`)}
      color={boardData.theme.primary}
    />
  );
};

BoardCard.propTypes = {
  boardData: PropTypes.object,
};

export default BoardCard;
